import React from "react"

const Spinner = ({ color, spinnerSize }) => <div className="d-flex align-items-center justify-content-center">
    <div className={`spinner-border text-${color ? color : 'primary'} ${spinnerSize === 'sm' && 'spinner-border-sm'}`} role="status">
        <span className="sr-only">Loading...</span>
    </div>
</div>

export default Spinner